import {useEffect, useMemo, useState} from "react";
import LatLngInput from "../../input/lat-lng-input.jsx";
import InputSlider from "../../input/input-slider.jsx";

export default function MapPointInput({ mapLabel = "Ponto no mapa", rangeLabel = "Raio (M)", corporation, latLng, range, onChangeLatLng, onChangeRange, className = "", sliderMin = 10, sliderMax = 1000, sliderStep = 1, showMap = true, showRange = true }) {
    const [makerPositionString, setMakerPositionString] = useState("");
    const [makerPosition, setMakerPosition] = useState(null);

    const position = useMemo(() => {
        const latitude = parseFloat(corporation?.latitude) || 0;
        const longitude = parseFloat(corporation?.longitude) || 0;

        return {
            lat: latitude,
            lng: longitude,
        }
    }, [corporation?.latitude, corporation?.longitude]);

    useEffect(() => {
        setMakerPositionString(latLng ?? "");
    }, [latLng]);

    return (
        <>
            <div className="space-y-4">
                {showMap && (
                    <LatLngInput
                        label={mapLabel}
                        position={position}
                        corporation={corporation}
                        value={latLng}
                        onChange={onChangeLatLng}
                        setMarkerPositionString={setMakerPositionString}
                        markerPositionString={makerPositionString}
                        setMarkerPosition={setMakerPosition}
                        markerPosition={makerPosition}
                        className={`w-full cursor-pointer ${className}`}
                    />
                )}
                {showRange && (
                    <InputSlider
                        label={rangeLabel}
                        value={range}
                        setValue={onChangeRange}
                        min={sliderMin}
                        max={sliderMax}
                        step={sliderStep}
                    />
                )}
            </div>
        </>
    )
}